import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputTimeComponent } from './components/input-time/input-time.component';
import { TextMaskModule } from 'angular2-text-mask';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  imports: [
    CommonModule,
    TextMaskModule,
    FormsModule,
    ReactiveFormsModule
  ],
  declarations: [InputTimeComponent],
  exports: [
    InputTimeComponent
  ]
})
export class InputTimeModule { }



// WEBPACK FOOTER //
// ./src/app/utils/input-time/input-time.module.ts